/* Lanivia: Kaching-bundels opschonen in DIT thema (Kaching-app zelf blijft onaangeroerd, dus live thema verandert niet).
   1) 'Voor 2:' en 'Hele gezin:' weg voor de groene regel
   2) kortingslabel (-xx% korting) witte letters, achtergrond blijft zwart
   3) 'xx vacuumzakken + x pompen' op 1 regel, schaalt licht mee op smalle schermen (min. 12px; past het dan nog niet, dan netjes 2 regels i.p.v. afgekapt) */
(function () {
  try {
    var PREFIX = /^\s*(Voor\s*2|Hele\s+gezin)\s*:\s*/i;
    var KORTING = /^\s*-?\s*\d+\s*%\s*korting\s*$/i;
    var POMPEN = /vacu[uü]mzakken\s*\+\s*\d*\s*pomp/i;
    var MIN_FS = 12;
    var fitted = [];

    function roots() {
      return document.querySelectorAll('kaching-bundle, .kaching-bundles__block, .kaching-bundles');
    }
    function blockOf(el) {
      var b = el;
      while (b && b.parentElement && /^inline/.test(getComputedStyle(b).display)) b = b.parentElement;
      return b;
    }
    function fit(el) {
      var b = blockOf(el);
      if (!b) return;
      if (fitted.indexOf(b) < 0) fitted.push(b);
      if (!b.dataset.lnvFs) b.dataset.lnvFs = parseFloat(getComputedStyle(b).fontSize) || 13;
      var fs = parseFloat(b.dataset.lnvFs);
      b.style.setProperty('white-space', 'nowrap', 'important');
      b.style.setProperty('min-width', '0', 'important');
      b.style.setProperty('font-size', fs + 'px', 'important');
      var g = 0;
      while (b.scrollWidth > b.clientWidth + 0.5 && fs > MIN_FS && g++ < 40) {
        fs = Math.max(MIN_FS, fs - 0.25);
        b.style.setProperty('font-size', fs + 'px', 'important');
      }
      if (b.scrollWidth > b.clientWidth + 0.5) b.style.setProperty('white-space', 'normal', 'important');
    }
    function korting(el) {
      el.style.setProperty('color', '#fff', 'important');
      el.querySelectorAll('*').forEach(function (c) { c.style.setProperty('color', '#fff', 'important'); });
    }
    function scan(root) {
      var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null), n;
      while ((n = w.nextNode())) {
        if (PREFIX.test(n.nodeValue)) n.nodeValue = n.nodeValue.replace(PREFIX, '');
      }
      root.querySelectorAll('*').forEach(function (el) {
        var t = el.textContent || '';
        if (KORTING.test(t) && !(el.parentElement && KORTING.test(el.parentElement.textContent || '') && el.parentElement !== root)) korting(el);
        if (POMPEN.test(t) && !Array.prototype.some.call(el.children, function (c) { return POMPEN.test(c.textContent || ''); })) fit(el);
        if (el.shadowRoot) scan(el.shadowRoot);
      });
    }
    var queued = false;
    function run() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; roots().forEach(scan); });
    }
    function start() {
      run();
      new MutationObserver(run).observe(document.body, { childList: true, subtree: true, characterData: true });
      window.addEventListener('resize', function () { fitted.forEach(fit); });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  } catch (e) {}
})();

if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      if (!activeMedia) return;
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  });
}
